import { useCallback, useRef } from 'react';
import { css, cx } from '@emotion/css';
import style from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowLeft from '@/components/UI/svg/Icons/EFArrowLeft';
import { createEFPic } from '@/utils/useEFPic';

type tab = {
    key: number;
    name: string;
    desc: string;
    img1: string[];
    img2: string[];
    gallery: string[];
};

const { EFPic } = createEFPic('/media/ces/pc/');

export default function sectionK() {
    const { useState, useLang, Link } = useGlobal();
    const { t } = useLang('ces2023.sectionG');
    const { t: t2 } = useLang('ces2023');

    const [currentTab, setCurrentTab] = useState(1);
    const [boxHeightMap, setHeightMap] = useState([]);

    const heightTmpRef = useRef<any>([]);

    const measuredRef = useCallback((node: HTMLDivElement, index: number) => {
        if (!node || !heightTmpRef.current) return;

        heightTmpRef.current[index] = node.clientHeight;
        const size = heightTmpRef.current.filter((i: any) => i).length;
        if (size === 3) {
            setHeightMap(heightTmpRef.current);
            heightTmpRef.current = null;
        }
    }, []);

    const tabs: tab[] = [
        {
            key: 0,
            name: t('tab1'),
            desc: t('tab1_tit'),
            img1: ['06-1.webp', '06-1.jpg'],
            img2: ['06-1-1.webp', '06-1-1.png'],
            gallery: [t('tab1_desc1'), t('tab1_desc2'), t('tab1_desc3'), t('tab1_desc4')],
        },
        {
            key: 1,
            name: t('tab2'),
            desc: t('tab2_tit'),
            img1: ['06-2.webp', '06-2.jpg'],
            img2: ['06-2-1.webp', '06-2-1.png'],
            gallery: [t('tab2_desc1'), t('tab2_desc2'), t('tab2_desc3'), t('tab2_desc4')],
        },
        {
            key: 2,
            name: t('tab3'),
            desc: t('tab3_tit'),
            img1: ['06-3.webp', '06-3.jpg'],
            img2: ['06-3-1.webp', '06-3-1.png'],
            gallery: [t('tab3_desc1'), t('tab3_desc2'), t('tab3_desc3'), t('tab3_desc4')],
        },
    ];

    const onClickTab = (e: any, key: number) => {
        setCurrentTab(key);
        e.preventDefault();
    };

    return (
        <div className={style.sectionK}>
            <div className="viewport-wrapper">
                <div className="tabs-bar">
                    <div className="tabs">
                        {tabs.map((tab: tab, index) => (
                            <div key={tab.key} className={`tab ${tab.key === currentTab ? 'select' : ''}`} onClick={(e) => onClickTab(e, tab.key)}>
                                {tab.name}
                                {index === 1 && (
                                    <div className="recommended">
                                        <div className="icon"></div>
                                        <div className="text">{t2('sectionG.recommended')}</div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="content">
                    <div
                        className={cx(
                            'desc',
                            css`
                                max-height: ${boxHeightMap[currentTab] ? `${boxHeightMap[currentTab]}px` : '1000px'};
                            `,
                        )}
                    >
                        {tabs.map((item, index) => {
                            return (
                                <div
                                    ref={(element: any) => measuredRef(element, index)}
                                    className={`desc-text ${index === currentTab ? 'active' : 'leave'}`}
                                    key={index}
                                >
                                    {item.desc}
                                </div>
                            );
                        })}
                    </div>
                    <div className="detail-box">
                        {tabs.map((item, index) => {
                            return (
                                <div className={`detail ${index === currentTab ? 'active' : 'leave'}`} key={index}>
                                    <EFPic className="img1" name={item.img1} />
                                    <div className="right">
                                        <EFPic className="img2" name={item.img2} />
                                        <ul className="gallery">
                                            {item.gallery.map((item, index) => (
                                                <li key={index}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <Link href="/whole-home-backup-power-solution">
                        <div className="learn-more">
                            {t('bottom_desc')} <EFArrowLeft color="#FFFFFF" />
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
}
